type ParseDurationResult =
  | {
      isValid: false;
    }
  | {
      isValid: true;
      seconds: number;
    };

export const formatDuration = (raw: string | undefined) =>
  (raw?.replace(/\D/g, '').match(/.{1,2}/g) ?? []).slice(0, 3).join(':');

export const parseDuration = (
  input: string | undefined,
): ParseDurationResult => {
  const match = /(\d{2}):(\d{2}):(\d{2})/.exec(input ?? '');

  if (!match) {
    return {
      isValid: false,
    };
  }

  const [_, ...groups] = match;
  return {
    isValid: true,
    seconds: groups.reduce(
      (previous, current, index) =>
        Number(current) * Math.pow(60, 2 - index) + previous,
      0,
    ),
  };
};

export function assertValidDuration(
  result: ParseDurationResult,
): asserts result is { isValid: true; seconds: number } {
  if (!result.isValid) throw new Error('Unexpected invalid duration result');
}

export const validateDuration = (input: string | undefined) => {
  const parsed = parseDuration(input);
  return parsed.isValid && parsed.seconds > 0;
};
